import { LightningElement } from "lwc";

export default class Waffle extends LightningElement {}
